var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import * as Styled from "ui/components/elements/undo-redo/undo-redo.style";
import { RedoIcon } from "ui/components/elements/icons/redo";
import { UndoIcon } from "ui/components/elements/icons/undo";
import { IconButton, } from "ui/components/elements/icons/icon-button";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
export var UndoRedo = function () {
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var canUndo = useAppSelector(selectors.selectCanUndo);
    var canRedo = useAppSelector(selectors.selectCanRedo);
    /* These dispatch custom undo/redo thunks (not the raw redux-undo actions)
     * so that undoing/redoing a deleteNode also re-syncs Tacton. */
    var handleUndoClick = function () {
        dispatch(actions.undo());
    };
    var handleRedoClick = function () {
        dispatch(actions.redo());
    };
    var iconButtonProps = {
        color: "inverted",
        variant: "rectangle",
        iconSize: 20,
    };
    return (_jsxs(Styled.Root, { children: [_jsx(IconButton, __assign({ disabled: !canUndo, onClick: handleUndoClick, rootAttributes: { style: { opacity: canUndo ? 1 : 0.4 } }, title: t("topbar.undo_redo") }, iconButtonProps, { children: _jsx(UndoIcon, {}) })), _jsx(IconButton, __assign({ disabled: !canRedo, onClick: handleRedoClick, rootAttributes: { style: { opacity: canRedo ? 1 : 0.4 } }, title: t("topbar.undo_redo") }, iconButtonProps, { children: _jsx(RedoIcon, {}) }))] }));
};
